import { Injectable } from '@angular/core';

import * as _ from 'lodash';
import { filter, of, take, tap, throttleTime } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';
import { formatLocale } from 'src/app/plasma-ui-common/utils/format-locale';
import { isInAvailableLocale } from 'src/app/transloco-root.module';
import { LocalStorageKeys } from 'src/app/models/storage.model';
import { UserClaimsService } from '../accounts/user-claims.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private jwt = new JwtHelperService();

  constructor(
    private authService: AuthService,
    private config: ConfigService,
    private readonly userClaim: UserClaimsService,
  ) {}
  canActivate() {
    this.getLangCodeBeforeSigninCallback();
    const isLoggedIn = this.authService.isLoggedInObs();
    const sessionTransferObj = JSON.parse(localStorage.getItem('session-transfer'));

    const accessToken = sessionTransferObj?.accessToken;
    if (accessToken) {
      this.authService.saveToState(accessToken);
      this.fetchClaims(accessToken);

      return of(true);
    } else {
      isLoggedIn.pipe(take(1), tap(isLoggedIn => {
        if (isLoggedIn) {
          const token = this.authService?._user.access_token;
          this.fetchClaims(token);
        } else {
          this.authService.signinRedirectTrigger$.next(Date.now());
        }
      })).subscribe();

      return isLoggedIn;
    }
  }

  private fetchClaims(token: string): void {
    const { sub, langCode } = this.jwt.decodeToken(token);
    this.userClaim.getUserClaims(sub);

    if (langCode) {
      this.userClaim.setAppLanguageFromJwtToken(langCode);
    }
  }

  private getLangCodeBeforeSigninCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const langCode = urlParams.get('langCode');

    if (langCode) {
      const configLanguages = this.config._envConfig?.AvailableLanguage?.split(',');
      let availableLanguages = [...(Array.isArray(configLanguages) ? configLanguages : [])].map(
        locale => formatLocale(locale, <any>this.config._envConfig),
      );

      const formattedLocale = formatLocale(
        isInAvailableLocale(langCode, availableLanguages),
        <any>this.config._envConfig,
      );
      sessionStorage?.setItem(LocalStorageKeys.language, formattedLocale);
    }
  }
}
